import apiClient from '../lib/apiClient';

const employeeCodeSettingsService = {
    // Get current employee code settings
    getSettings: async () => {
        try {
            const result = await apiClient.get('/employee-code-settings');
            return result;
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Failed to fetch settings'
            };
        }
    },

    // Update employee code settings
    updateSettings: async (settings) => {
        try {
            const result = await apiClient.put('/employee-code-settings', settings);
            return result;
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Failed to update settings'
            };
        }
    },

    // Preview next employee code
    previewNextCode: async () => {
        try {
            const result = await apiClient.get('/employee-code-settings/preview');
            return result;
        } catch (error) {
            return {
                success: false,
                error: error.message || 'Failed to preview code'
            };
        }
    }
};

export default employeeCodeSettingsService;
